module.exports = __webpack_public_path__ + "static/media/img-2.4533d775.jpg";